import { TransactionType } from "@/enums/enums";
import { SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class TransactionService {
  DoGetTransactionNumberByTransactionId(transactionIdList: Array<number>, transactionType: TransactionType) {
    const _input = {
      transactionIdList: transactionIdList,
      transactionType: transactionType,
    };
    return service.peakExportAPI
      .post("/api/Transaction/GetTransactionNumberByTransactionId", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new TransactionService();
